export const environment = {
  production: false,
  api_url: 'https://api-preview.bemum.co',
  crisp_chat_url: 'https://app.crisp.chat/website/6962c3bc-844b-4c7b-abc1-5e73e7eb790c/inbox/',
};
